import { useIsPWA } from 'app/hooks/useIsPWA';

// Static DOM attribute — never changes after initial page load.
const isTranslatorApp =
  typeof document !== 'undefined' ? document.documentElement.dataset.pwaApp === 'translator' : false;

/**
 * Hook that checks if the app is running as a standalone Translator PWA.
 * Returns true only if both conditions are met:
 * 1. The app is running in standalone PWA mode
 * 2. The app is the Translator PWA (data-pwa-app="translator")
 */
export const useIsTranslatorStandalone = (): boolean => {
  const isPWA = useIsPWA();
  return isPWA && isTranslatorApp;
};
